import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import '../Styles/Blog.css';

// Mock blog data
const mockBlogs = [
  {
    _id: '1',
    title: 'The Future of Cybersecurity in 2024',
    excerpt: 'Exploring the latest trends and predictions in cybersecurity for the coming year and how businesses can prepare.',
    image: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80',
    category: 'Cybersecurity',
    date: '2024-11-15',
    readTime: '5 min read'
  },
  {
    _id: '2',
    title: 'Understanding Zero Trust Architecture',
    excerpt: 'A comprehensive guide to implementing Zero Trust security models in modern enterprise environments.',
    image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80',
    category: 'Security',
    date: '2024-11-10',
    readTime: '7 min read'
  },
  {
    _id: '3',
    title: 'Blockchain Technology: Beyond Cryptocurrency',
    excerpt: 'How blockchain is revolutionizing industries beyond finance, from supply chain to healthcare.',
    image: 'https://images.unsplash.com/photo-1622547748225-3fc4abd2cca0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80',
    category: 'Blockchain',
    date: '2024-11-05',
    readTime: '6 min read'
  },
  {
    _id: '4',
    title: 'AI and Machine Learning in Cybersecurity',
    excerpt: 'How artificial intelligence is being used to detect and prevent sophisticated cyber threats.',
    image: 'https://images.unsplash.com/photo-1535378917042-10a22c95931a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80',
    category: 'AI',
    date: '2024-10-28',
    readTime: '8 min read'
  },
  {
    _id: '5',
    title: 'Cloud Security Best Practices',
    excerpt: 'Essential security measures every organization should implement when moving to the cloud.',
    image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1374&q=80',
    category: 'Cloud',
    date: '2024-10-20',
    readTime: '6 min read'
  },
  {
    _id: '6',
    title: 'The Rise of Quantum Computing',
    excerpt: 'Understanding how quantum computing will impact encryption and data security in the near future.',
    image: 'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80',
    category: 'Quantum',
    date: '2024-10-15',
    readTime: '9 min read'
  }
];

function Blog() {
    const [allBlogs, setAllBlogs] = useState([]);
    const [filteredBlogs, setFilteredBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [activeFilter, setActiveFilter] = useState('All Articles');
    const blogsPerPage = 6;

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                // Using mock data instead of API call
                setAllBlogs(mockBlogs);
                setFilteredBlogs(mockBlogs);
                setLoading(false);
            } catch (error) {
                console.error('Error loading blogs:', error);
                setError('Failed to load blogs. Please try again later.');
                setLoading(false);
            }
        };

        // Simulate network delay
        const timer = setTimeout(() => {
            fetchBlogs();
        }, 500);

        return () => clearTimeout(timer);
    }, []);

    if (loading) {
        return (
            <div className="blog-loading">
                <Navbar />
                <div className="loading-spinner"></div>
                <p>Loading latest articles...</p>
                <Footer />
            </div>
        );
    }

    // Filter blogs based on active filter
    const filterBlogs = (filter) => {
        setActiveFilter(filter);
        setCurrentPage(1); // Reset to first page when changing filters
        
        if (filter === 'All Articles') {
            setFilteredBlogs(allBlogs);
        } else {
            const filtered = allBlogs.filter(blog => blog.category === filter);
            setFilteredBlogs(filtered);
        }
    };

    // Pagination logic
    const indexOfLastBlog = currentPage * blogsPerPage;
    const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
    const currentBlogs = filteredBlogs.slice(indexOfFirstBlog, indexOfLastBlog);
    const totalPages = Math.ceil(filteredBlogs.length / blogsPerPage);

    // Change page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    if (error) {
        return (
            <div className="blog-error">
                <Navbar />
                <div className="error-message">
                    <h2>Oops! Something went wrong</h2>
                    <p>{error}</p>
                    <button onClick={() => window.location.reload()}>Try Again</button>
                </div>
                <Footer />
            </div>
        );
    }

    return (
        <div className='blog'>
            <Navbar />
            <div className='blog-hero'>
                <div className='blog-hero-content'>
                    <h1>OnexInfinity Blog</h1>
                    <p>Insights, guides, and updates on cybersecurity, technology, and innovation</p>
                </div>
            </div>
            <div className='blog-container'>
                <div className='blog-filters'>
                    {['All Articles', 'Cybersecurity', 'AI', 'Blockchain', 'Cloud', 'Quantum'].map((filter) => (
                        <button 
                            key={filter}
                            className={activeFilter === filter ? 'active' : ''}
                            onClick={() => filterBlogs(filter)}
                        >
                            {filter}
                        </button>
                    ))}
                </div>
                
                {filteredBlogs.length === 0 ? (
                    <div className="no-results">
                        <h3>No articles found in this category.</h3>
                        <button onClick={() => filterBlogs('All Articles')}>Show All Articles</button>
                    </div>
                ) : (
                    <div className='blog-grid'>
                    {currentBlogs.map((blog) => (
                        <article key={blog._id} className='blog-card'>
                            <div className='blog-card-inner'>
                                <div className='blog-image'>
                                    <img 
                                        src={blog.image} 
                                        alt={blog.title} 
                                        loading="lazy"
                                    />
                                    <span className='blog-category'>{blog.category}</span>
                                </div>
                                <div className='blog-content'>
                                    <h2>{blog.title}</h2>
                                    <p className='blog-excerpt'>{blog.excerpt}</p>
                                    <div className='blog-meta'>
                                        <time dateTime={blog.date}>
                                            {new Date(blog.date).toLocaleDateString('en-US', { 
                                                year: 'numeric', 
                                                month: 'long', 
                                                day: 'numeric' 
                                            })}
                                        </time>
                                        <span className='blog-read-time'>{blog.readTime}</span>
                                    </div>
                                </div>
                            </div>
                        </article>
                    ))}
                    </div>
                )}
                
                {totalPages > 1 && (
                    <div className='blog-pagination'>
                        {Array.from({ length: Math.min(3, totalPages) }, (_, i) => {
                            // Always show first page, current page, and last page
                            let pageNumber;
                            if (currentPage <= 2) {
                                pageNumber = i + 1;
                            } else if (currentPage >= totalPages - 1) {
                                pageNumber = totalPages - 2 + i;
                            } else {
                                pageNumber = currentPage - 1 + i;
                            }
                            
                            if (pageNumber > 0 && pageNumber <= totalPages) {
                                return (
                                    <button 
                                        key={pageNumber}
                                        className={currentPage === pageNumber ? 'active' : ''}
                                        onClick={() => paginate(pageNumber)}
                                    >
                                        {pageNumber}
                                    </button>
                                );
                            }
                            return null;
                        })}
                        
                        {currentPage < totalPages - 1 && totalPages > 3 && (
                            <button 
                                className='next' 
                                onClick={() => paginate(currentPage + 1)}
                                disabled={currentPage === totalPages}
                            >
                                &rarr;
                            </button>
                        )}
                    </div>
                )}
            </div>
            <Footer />
        </div>
    );
}

export default Blog;